import 'styles/global';

import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { createBrowserHistory } from 'history';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@qga/roo-ui';
import { ModalGlobalStyle } from '@qga/roo-ui/components';
import { ApolloProvider } from '@apollo/react-hooks';
import * as Sentry from '@sentry/browser';

import { ROUTER_BASENAME } from 'config/env';
import theme from 'styles/theme';
import App from 'components/App';
import { createClient } from 'lib/graphql';

import routes from './routes';

import { QffUserProvider } from 'hooks/useQffUser';
import { ModalProvider } from 'hooks/useModal';

export const initialize = () => {
  const history = createBrowserHistory({ basename: ROUTER_BASENAME });
  const client = createClient();

  const root = document.getElementById('root');

  history.listen((location) => {
    window.dataLayer.push({ event: 'gaPageview' });

    Sentry.addBreadcrumb({
      category: 'route-change',
      message: location.pathname,
      data: { pathname: location.pathname, search: location.search },
      level: Sentry.Severity.Info,
    });
  });

  Modal.setAppElement(root);

  ReactDOM.render(
    <ApolloProvider client={client}>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <QffUserProvider>
          <ThemeProvider theme={theme}>
            <ModalProvider>
              <ModalGlobalStyle />
              <App>{routes}</App>
            </ModalProvider>
          </ThemeProvider>
        </QffUserProvider>
      </BrowserRouter>
    </ApolloProvider>,
    root,
  );
};
